export const VALUES = [
  { id: "environment", label: "Environment" },
  { id: "education",   label: "Education" },
  { id: "health",      label: "Health & Wellbeing" },
  { id: "community",   label: "Community" },
  { id: "youth",       label: "Youth" },
  { id: "elderly",     label: "Elderly Care" },
  { id: "homelessness",label: "Homelessness" },
  { id: "animals",     label: "Animal Welfare" },
  { id: "arts",        label: "Arts & Culture" },
  { id: "tech-for-good", label: "Tech for Good" },
];

export const SKILLS = [
  "design", "photography", "video", "strategy", "social-media",
  "tutoring", "mentoring", "leadership", "languages",
  "gardening", "operations", "cooking", "driving",
  "marketing", "fundraising", "events", "first-aid",
  "tech-ai", "data", "translation", "finance",
];

const SKILL_LABELS = { "tech-ai": "Tech / AI", "first-aid": "First aid", "social-media": "Social media" };
export const skillLabel = (s) => SKILL_LABELS[s] || s.replace(/-/g, " ");

export const APP_STATUS = {
  applied: { label: "Pending review", cls: "bg-amber-100 text-amber-800" },
  accepted: { label: "Accepted", cls: "bg-forest text-white" },
  rejected: { label: "Declined", cls: "bg-red-100 text-red-700" },
  expired: { label: "Expired", cls: "bg-neutral-200 text-neutral-600" },
  cancelled: { label: "Cancelled", cls: "bg-neutral-200 text-neutral-600" },
};

// Landing hero (2026-07, v2): aerial/drone view down a bunting-lined UK
// terraced street with one long trestle table of neighbours. Locally bundled
// + webp-optimised (no hotlinking).
import heroStreetParty from "../assets/hero-street-party.webp";
export const HERO_IMAGE = heroStreetParty;
export const COMMUNITY_IMAGE = "https://images.unsplash.com/photo-1758691736975-9f7f643d178e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHwxfHxkaXZlcnNlJTIwdGVhbSUyMHNtaWxpbmclMjBwb3J0cmFpdHxlbnwwfHx8fDE3ODI1OTc5Njh8MA&ixlib=rb-4.1.0&q=85";
export const ORG_IMAGE = "https://images.unsplash.com/photo-1568992688065-536aad8a12f6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBvZmZpY2UlMjBtZWV0aW5nJTIwdGVhbSUyMGNvbGxhYm9yYXRpbmd8ZW58MHx8fHwxNzgyNTk3OTY4fDA&ixlib=rb-4.1.0&q=85";
// Phase 11 landing refresh — neighbour-help + collectives sections
export const NEIGHBOUR_IMAGE = "https://images.unsplash.com/photo-1544784158-a7f055cc905e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHw0fHxuZWlnaGJvdXIlMjBoZWxwaW5nJTIwZWxkZXJseSUyMGdyb2NlcmllcyUyMGRvb3JzdGVwfGVufDB8fHx8MTc4MzYwNjQzMXww&ixlib=rb-4.1.0&q=85";
export const GATHERING_IMAGE = "https://images.unsplash.com/photo-1743423888198-134039b6d742?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHwxfHxjb21tdW5pdHklMjBzdHJlZXQlMjBwYXJ0eSUyMG5laWdoYm91cnMlMjBnYXRoZXJpbmclMjBVS3xlbnwwfHx8fDE3ODM2MDY0MzF8MA&ixlib=rb-4.1.0&q=85";
